import { TranslateService } from '@ngx-translate/core';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { MessengerService } from './messenger.service';
import { AppointmentConfirm } from 'src/app/appointment/model/appointment-confirm';
@Injectable({
  providedIn: 'root'
})
export class AppointmentService implements OnDestroy
{
  public schedulerViews: Array<{ text: string; value: string }> = [
    { text: 'Day', value: 'DAY' },
    { text: 'Multi Days', value: 'MULTI_DAY' },
    { text: 'Week', value: 'WEEK' },
    { text: 'Work Week', value: 'WORK_WEEK' },
    { text: 'Month', value: 'MONTH' },
    { text: 'Week Timeline', value: 'WEEK_TIMELINE' },
    { text: 'Agenda', value: 'AGENDA' }
  ];

  public days: Array<{ text: string; value: string }> = [
    { text: 'Sunday', value: '0' },
    { text: 'Monday', value: '1' },
    { text: 'Tuesday', value: '2' },
    { text: 'Wednesday', value: '3' },
    { text: 'Thursday', value: '4' },
    { text: 'Friday', value: '5' },
    { text: 'Saturday', value: '6' }
  ];

  private messagingLanguageChangedSubscription: Subscription;

  constructor(private http: HttpClient,
    private translate: TranslateService,
    private messengerService: MessengerService)
  {
    this.loadLocalizations();
    this.messagingLanguageChangedSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations();
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get the day text to display.
   *
   *@param day Day value.
   */
  public getDayDisplayText(day: string): string
  {
    let text = day;
    const dayObject = this.days.find(x => x.value === day);
    if (dayObject !== undefined)
    {
      text = dayObject.text;
    }
    return text;
  }

  /**
   * Get the Scheduler view text to display.
   *
   * @param type Scheduler view value.
   */
  public getSchedulerViewTypeText(type: string): string
  {
    let text = type;
    const typeObject = this.schedulerViews.find(x => x.value === type);
    if (typeObject !== undefined)
    {
      text = typeObject.text;
    }
    return text;
  }

  /**
   * Convert a list of Scheduler Views to views texts.
   *
   * @param views List of Scheduler viers.
   */
  public convertViewsToDisplayTexts(views: string): string
  {
    const res = views.split(',');
    const viewsText = [];
    res.forEach(view =>
    {
      const viewText = this.getSchedulerViewTypeText(view);
      if (viewText !== '')
      {
        viewsText.push(viewText);
      }
    });
    return viewsText.join();
  }

  /**
   * Get Appointment by id.
   *
   * @param id Appointment id
   */
  public getAppointment(id: number): Observable<any>
  {
    return this.http.get<any>(`/event/${id}`);
  }

  /**
   * Get Appointment by id.
   *
   * @param id Appointment id
   */
  public getAppointmentsByMember(memberId: number): Observable<any>
  {
    return this.http.get<any>(`/event/member/${memberId}`);
  }

  /**
   * Cancel Appointment.
   *
   * @param data Appointment cancel reason
   */
  public cancelAppointment(data: any): Observable<any>
  {
    return this.http.put<any>('/appointment/cancel', data);
  }

  /**
   * Get Appointment by id.
   *
   * @param id Appointment id
   */
  public getAppointmentByEvent(id: number): Observable<any>
  {
    return this.http.get<any>(`/appointment/event/${id}`);
  }

  /**
   * Save an Appointment event.
   *
   * @param data Appointment event to persit
   * @param isNew Indicate if this is a new or update
   */
  public saveAppointment(data: any, isNew: boolean, eventId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/appointment', data);
    }
    else
    {
      return this.http.put(`/appointment/${eventId}`, data);
    }
  }

  /**
   * Resend Appointment.
   *
   * @param id Event id
   */
  public resendAppointment(eventId: number): Observable<any>
  {
    return this.http.post<any>(`/appointment/resend/${eventId}`, null);
  }

  /**
   * Delete Appointment.
   *
   * @param id Event id
   */
  public deleteAppointment(eventId: number): Observable<any>
  {
    return this.http.delete<any>(`/appointment/delete/${eventId}`);
  }

  /**
   * Confirm Appointment.
   *
   * @param data Appointment id
   */
  public confirmAppointment(data: AppointmentConfirm): Observable<any>
  {
    return this.http.put(`/appointment/confirm/email`, data);
  }

  /**
   * Load localizations
   */
  private loadLocalizations(): void
  {
    setTimeout(() =>
    {
      this.translate.get(['SCHEDULER-VIEWS', 'DAYS']).subscribe({
        next: (res: any) =>
        {
          let splitted = res['SCHEDULER-VIEWS'].split(',');
          for (let i = 0; i < splitted.length; i++)
          {
            if (this.schedulerViews.length > i)
            {
              this.schedulerViews[i].text = splitted[i];
            }
          }

          splitted = res.DAYS.split(',');
          for (let i = 0; i < splitted.length; i++)
          {
            if (this.days.length > i)
            {
              this.days[i].text = splitted[i];
            }
          }
        }
      });
    });
  }
}
